import { component$ } from '@builder.io/qwik';
import type { HtmlEmbedBlockInterface } from '~/types/AppData/PageBuilder/HtmlEmbedBlockInterface';

export default component$<HtmlEmbedBlockInterface['props']>(({ value }) => {
  return <div dangerouslySetInnerHTML={value} />;
});
